import * as React from "react";
export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
    return <input className="mc-input" {...props} />;
}
